import React, {useState } from "react";
import QRcode from "../../components/qr_view/QR";
import Link from 'next/link';
import Snackbar from '@material-ui/core/Snackbar'



const WithdrawView = ({ hash, invoice, number}) => {
    const [open, setOpen] = useState(false);

    async function copyTextToClipboard(text) {
        setOpen(true);
        setTimeout(()=>{
          setOpen(false);
        },1000);
        if ('clipboard' in navigator) {
          return await navigator.clipboard.writeText(text);
        } else {
          return document.execCommand('copy', true, text);
        }
      }
    

    return(
        <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
            기프트콘 발행 완료
            </h1>   
            <Link href={"/claim/"+hash}>
            <a>
                <h3 className="font-display text-jacarta-700 text-center text-1xl font-medium dark:text-white">
                기프트콘 {number}개 상세보기 (클릭)
                </h3>
            </a>
            </Link>
            <a onClick={()=>{copyTextToClipboard('https://yanabu.com/claim/'+hash)}}>
            <h3 className="font-display text-jacarta-700 py-2 text-center text-1xl font-medium dark:text-white">
            기프트콘 주소 복사하기
            </h3>            
            </a>
        
            <div className="mx-auto max-w-2xl">
                {invoice!=""&&<QRcode text={invoice}></QRcode>}
            </div>

            <Snackbar open={open} message="Copied."/>
        </div>
    )
}

export default WithdrawView;
